<template>
  <div class="chat-input">
    <div class="chat-input-list-content" :style="{top: -37 * sugList.length + 54 + 'px'}">
      <div v-for="(item, index) in sugList" @click="toInfo(item)" :key="index" class="chat-input-list">
          <div slot="title" v-html="heightLight(item.questionContent)"></div>
      </div>
    </div>
    <div class="themList" v-if="inputFlag">
      <div class="wrapper">
        <div class="my-inbox" ref="box" @click.prevent="">
          <div
            v-for="(item, index) in nextNodeList"
            :key="index"
            class="tree-item "
            @click="getNextNode(item)">
              {{ item.name }}
          </div>
        </div>
      </div>
      <div class="keyboard" @click="changeInput"><span class="iconfont">&#xe618;</span></div>
    </div>
    <div class="chat-input-panel" v-else>
      <div class="defaultQuestion">
        <div class="my-inbox" ref="box" @click.prevent="">
          <div
            v-for="(item, index) in questionList"
            :key="index"
            :class="['tree-item', {'no-click': refresh}] "
            @click="toInfo(item)">
              {{ item.questionContent }}
          </div>
        </div>
      </div>
      <div class="chat-input-panel-out flex">
        <!-- <span @click="changeAI" :class="`chat-input-panel-span${isAI ? '' : '-ai'}`">智</span> -->
        <!-- <span @click="changeAI" :class="['chat-input-panel-span',{'chat-input-panel-span-ai': isAI}]">AI</span> -->
        <!-- <span @click="changeAI" :class="['icon iconfont', {'iconfontC': isAI}, {'no-click': refresh}]">&#xe7b2;</span> -->
        <div class="chat-input-panel-inner">
          <input
            class="chat-input"
            ref="inputRef"
            placeholder="请输入您的问题"
            style="font-size: 14px"
            v-model="text"
            @keydown.enter="handleSend"
            enterkeyhint="send"
            :disabled="refresh"
            @focus="onFocus"
          />
          <button class="chat-input-send" @click="handleSend" :disabled="refresh">
            发送
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { autoGrowTextArea } from "@/utils";
export default {
  data() {
    return {
      rows: 3,
      text: "",
      lastOperationTime: new Date().getTime(),
      showOver: false,
      num: 1,
      over: false,
      refresh: false,
      nextNodeList: this.$store.state.nextNode,
      inputFlag: false,
      sugList: [],
      questionList: [],
      isAI: false
    };
  },
  components: {},
  computed: {
    
  },
  watch: {
    num() {
      cancelAnimationFrame(this.myReq);
    },
    '$store.state.loadingState': {
      handler(newVal,oldVal){
        this.refresh = newVal
      },
      deep: true,
    },
    '$store.state.nextNode': {
      handler(newVal,oldVal){
        this.nextNodeList = newVal
        this.inputFlag = newVal.length > 0 ? true :  false
      },
      deep: true,
    },
    text: {
      handler(val) {
        if(val) {
          this.getQueryList(val)
        }else{
          this.sugList = []
        }
      }
    }
  },
  methods: {
    // 切换会话模式
    changeAI() {
      this.isAI = !this.isAI;
      console.log('会话模式',this.isAI)
      this.$store.commit('SET_AI', this.isAI);
      this.$store.commit('SET_BUBBLE', false);
    },
    // 
    getDefaultQuestion(e) {
      this.$axios.get("/conversation/list/recommend_result", { result: e || ''}).then((res) => {
        console.log('获取底部推荐问题',res)
        this.questionList = res.content;
      }).catch((err) => {
        this.questionList = []
      });
    },
    // 关键字的数据列表点击
    toInfo(item) {
      this.$emit("toInfo", item);
      this.$store.commit('SET_BUBBLE', false);
      this.text = ''
      this.sugList = []
    },
    // 根据输入的关键字 高亮显示
    heightLight(str) {
        console.log('高亮',str);
        if (str) {
          const reg = new RegExp(this.text, 'gi')
          return str.replace(reg, `<span class="lightBox" >${this.text}</span>`)
        }
    },
    getQueryList(val) {
      this.$axios.get("/conversation/list/recommend", {keyword: val}).then((res) => {
        console.log('实时获取3条数据',res)
        this.sugList = res.content.slice(0, 3);
      }).catch((err) => {
        this.sugList = []
      });
    },
    changeInput() {
      this.inputFlag = !this.inputFlag;
      this.$store.commit('SET_THEME_STATE', this.inputFlag);
      this.$store.commit('SET_ARR', []);
    },
    getNextNode(item) {
      this.$emit("getNextNode", item);
    },
    onFocus(item) {
      
      this.$emit("onFocus",item);
    },
    clickMenuItem: function(item) {
      console.log(item.name);
    },
    handleClick(item) {

    },
    handleOver() {
      this.$axios.post("/conversation/end").then((res) => {
        if (res.status == 0) {
          cancelAnimationFrame(this.myReq);
          this.showOver = false;
          this.over = true;
          this.$emit("over");
        }
      });
    },

    animate(cb, time) {
      let i = 1;
      let that = this;
      that.myReq = requestAnimationFrame(function fn() {
        if (i % parseInt(60 / (1000 / time)) == 0) {
          cb();
        }
        i++;
        that.myReq = requestAnimationFrame(fn);
      });
    },
    handleSend() {
      this.$store.commit('SET_BUBBLE', false);
      cancelAnimationFrame(this.myReq);
      this.lastOperationTime = new Date().getTime();
      this.$emit("send", this.text);
      this.text = "";
      this.showOver = false;
      this.animate(() => {
        if (new Date().getTime() - this.lastOperationTime > 60 * 1000) {
          this.showOver = true;
          this.num++;
        }
      }, 1000);
    },
    handleInput(e) {
      let rows = autoGrowTextArea(this.$refs.inputRef);
      this.rows = Math.min(8, Math.max(3, rows));
    },
  },

  mounted() {
    this.animate(() => {
      if (new Date().getTime() - this.lastOperationTime > 60 * 1000) {
        this.showOver = true;
        this.num++;
      }
    }, 1000);
    this.getDefaultQuestion();
  },
};
</script>
<style lang="scss" scoped>
.no-click {
  pointer-events: none;
}
.chat-input {
  width: 100%;
  // padding: 5px 20px 15px 5px;
  box-sizing: border-box;
  // border-top: 1px solid rgba(222, 222, 222, 1);
  position: relative;
  // 新增的
  display: flex;

  .over-button {
    position: absolute;
    top: -42px;
    left: 10px;
  }
  .chat-input-list-content{
    position: absolute;
    // top: -111px;
    background: #fff;
    width: 100%;
    left: 0;
    z-index: 999;
  }
  
  .chat-input-list{
    height: 36px;
    padding: 0 20px;
    line-height: 36px;
    border-bottom: 1px solid #eaeaeb;
    font-size: 12px;
    color: #666;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &:last-of-type {
      border: none
    }
    ::v-deep span.lightBox{
      color: #3b62f1;
    }
  }
  // height: 100%;

  // 新增的
  .chat-input-panel {
    flex: 1;
    width: 100%;
    .defaultQuestion {
      width: 100%;
      padding: 10px 0 10px 70px;
      box-sizing: border-box;
      background: #e2e3f7;
      .my-inbox {
        overflow-y: hidden;
        overflow-x: scroll;
        width: 100%;
        white-space: nowrap;
        &::-webkit-scrollbar {
          height: 0;
        }
        .tree-item {
          background: #f5f6f8;
          display: inline-block;
          line-height: 28px;
          margin-right: 5px;
          // margin-bottom: 8px;
          padding: 0px 15px;
          text-align: center;
          font-size: 12px;
          border-radius: 15px;
        }
      }
    }
  }
  .chat-input-panel-out{
    background: #fff;
    padding: 15px 20px;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    .iconfont{
      font-size: 25px;
      line-height: 38px;
      margin-right: 10px;
      color: #333;
    }
    .iconfontC{
      color: #3b62f1;
    }
  }
  .chat-input-panel-inner {
    display: flex;
    flex: 1;
    background: #f4f6f8;
    border-radius: 25px;
  }
  .chat-input-panel-span {
    font-size: 14px;
    width: 26px;
    height: 26px;
    display: inline-block;
    border: 1px solid #333;
    border-radius: 50%;
    text-align: center;
    line-height: 26px;
    font-weight: bold;
    margin: 6px 8px 0 0;
    cursor: pointer;
  }
  .chat-input-panel-span-ai {
    border: 1px solid #3b62f1;
    color: #3b62f1;
  }
  .chat-input-send {
    // 之前的
    // position: absolute;
    // right: 30px;
    // padding: 12px;
    // bottom: 30px;

    background: #3b62f1;
    color: white;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    outline: none;
    border: none;
    width: 25%;
    font-size: 16px;

    // 新增的
    padding: 8px 12px;
    margin-left: 10px;
    div{
      margin: 3px 3px 0 0;
    }
  }
  textarea {
    height: 100%;
    width: 100%;
    border-radius: 10px;
    border: 1px solid rgba(222, 222, 222, 1);
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.03);
    padding: 10px 90px 10px 14px;
    resize: none;
    outline: none;
    box-sizing: border-box;
    min-height: 68px;
  }

  // 新增的
  .chat-input {
    padding: 10px 20px;
    border: none;
    background: #f4f6f8;
    border-radius: 25px;
    border: 1px solid #f4f6f8;
    &:focus {
      outline: none;
      // border: 1px solid rgba(29, 147, 171);
      // box-shadow: 0 0 3px rgba(29, 147, 171);
    }
  }
  .chat-input-actions{
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    .themeList{
      width: 80%;
      div{
        width: 100px;
        padding: 5px;
        background: #f5f6f8;
        margin-right: 10px;
        float: left;
      }
    }
  }
}
.slide-menu {
  position: relative;
}

.menu-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 300px;
  background-color: #f1f1f1;
  transition: transform 0.3s ease;
}

.menu-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.toggle-button {
  position: fixed;
  top: 10px;
  right: 10px;
  padding: 10px;
  border: none;
  background-color: #f1f1f1;
  cursor: pointer;
}
.themList{
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 15px 20px 15px 70px;
  box-sizing: border-box;
  background: #fff;
  .wrapper {
    width: 82%;
    .my-inbox {
      overflow-y: hidden;
      overflow-x: scroll;
      width: 100%;
      white-space: nowrap;
      &::-webkit-scrollbar {
        height: 0;
      }
      .tree-item {
        background: #f5f6f8;
        display: inline-block;
        line-height: 38px;
        margin-right: 5px;
        margin-bottom: 8px;
        padding: 0px 15px;
        text-align: center;
        font-size: 14px;
        border-radius: 5px;
      }
    }
  }
  .keyboard{
    background: #3b62f1;
    color: #fff;
    width: 50px;
    text-align: center;
    border-radius: 5px;
    height: 38px;
    .iconfont{
      font-size: 28px;
      line-height: 38px;
    }
  }
}
</style>
